const emailFontList = [
    { value: 'Arial', label: 'Arial' },
    { value: 'Arial Black', label: 'Arial Black' },
    { value: 'Comic Sans', label: 'Comic Sans' },
    { value: 'Courier New', label: 'Courier New' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Impact', label: 'Impact' },
    { value: 'Charchoal', label: 'Charcoal' },
    { value: 'Lucida Console', label: 'Lucida Console' },
    { value: 'Lucida Sans Unicode', label: 'Lucida Sans Unicode' },
    { value: 'Lucida Grande', label: 'Lucida Grande' },
    { value: 'Palatino Linotype', label: 'Palatino Linotype' },
    { value: 'Helvetica', label: 'Helvetica' },
    { value: 'Book Antiqua', label: 'Book Antiqua ' },
    { value: 'Palantino', label: 'Palantino' },
    { value: 'Tahoma', label: 'Tahoma' },
    { value: 'Geneva', label: 'Geneva' },
    { value: 'Times', label: 'Times New' },
    { value: 'Times New Romas', label: 'Times New Roman' },
    { value: 'Trebuchet MS', label: 'Trebuchet MS' },
    { value: 'Monaco', label: 'Monaco' },
    { value: 'Verdana', label: 'Verdana' },
];
export function emailFonts() {
    return emailFontList.sort(function (a, b) {
        if (a < b) {
            return -1;
        }
        if (b > a) {
            return 1;
        }
        return 0;
    });
}